import React from "react";
import { ResponsiveBar } from "@nivo/bar";

const PercentageCompletionGraph = ({ data }) => {
  // Custom component to display percentage values on top of bars
  const ValueLabel = ({ bars }) => {
    return bars.map((bar) => {
      const {
        key,
        width,
        height,
        x,
        y,
        data: { value },
      } = bar;
      
      return (
        <g key={key} transform={`translate(${x}, ${y - 10})`}>
          <text
            x={width / 2}
            textAnchor="middle"
            fontSize="12px"
            fontWeight="bold"
            fill="#333"
          >
            {`${value}%`}
          </text>
        </g>
      );
    });
  };

  return (
    <div style={{ height: "400px" }}>
      <ResponsiveBar
        data={data}
        keys={["value"]}
        indexBy="label"
        margin={{ top: 50, right: 30, bottom: 120, left: 60 }} // Increased bottom margin for more space
        padding={0.3}
        valueScale={{ type: "linear" }}
        indexScale={{ type: "band", round: true }}
        colors={"#e86d28"} // Orange color from the image
        borderColor={{ from: "color", modifiers: [["darker", 1.6]] }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0, // Changed from -45 to 0 to make labels horizontal
          legend: "",
          legendPosition: "middle",
          legendOffset: 32,
          renderTick: ({ x, y, value }) => (
            <g transform={`translate(${x},${y+15})`}> {/* Added +15 to y to move labels down */}
              <text
                textAnchor="middle"
                dominantBaseline="text-before-edge"
                style={{
                  fontSize: '12px',
                  fill: '#333',
                  paddingTop: '15px' // Added padding to increase space
                }}
              >
                {value}
              </text>
            </g>
          )
        }}
        axisLeft={{
          tickSize: 5,
          tickPadding: 5,
          tickRotation: 0,
          legend: "% Complete",
          legendPosition: "middle",
          legendOffset: -40,
          tickValues: [0, 50, 100]
        }}
        enableLabel={false} // Disable internal labels
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        layers={["grid", "axes", "bars", "markers", ValueLabel]}
        maxValue={100}
        enableGridY={true}
        enableGridX={false}
        gridYValues={[0, 50, 100]}
        theme={{
          axis: {
            ticks: {
              line: {
                stroke: "#e0e0e0"
              },
              text: {
                fill: "#333",
                fontSize: 12
              }
            },
            legend: {
              text: {
                fill: "#333",
                fontSize: 14,
                fontWeight: 600
              }
            }
          },
          grid: {
            line: {
              stroke: "#e0e0e0",
              strokeWidth: 1,
              strokeDasharray: "2, 4"
            }
          }
        }}
      />
    </div>
  );
};

export default PercentageCompletionGraph;
